<template>
  <q-select
    v-bind="$props"
    option-label="name"
    option-value="accounting_id"
    dense
    hide-bottom-space
    @update:model-value="$emit('update:modelValue', $event)"
    @clear="$emit('clear')"
  >
    <template #no-option>
      <no-results
        align="left"
        title="No results to display"
        without-icon
      />
    </template>
    <template #option="scope">
      <q-item-wrapper
        v-bind="scope.itemProps"
      >
        <q-item-section>
          <q-item-label>
            <span :class="{'text-bold text-clickable': scope.selected}">
              {{ scope.opt.name }}
            </span>
            <span class="q-pl-xs">
              {{ scope.opt.rate }}%
            </span>
          </q-item-label>
        </q-item-section>
      </q-item-wrapper>
    </template>
    <template #selected-item="scope">
      <q-item-section>
        <q-item-label>
          <span class="text-bold text-clickable">
            {{ scope.opt.name }}
          </span>
          <span class="q-pl-xs">
            {{ scope.opt.rate }}%
          </span>
        </q-item-label>
      </q-item-section>
    </template>
  </q-select>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    outlined: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String
    },
    label: {
      type: String
    },
    hint: {
      type: String
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'clear']
}
</script>
